export default {
  apiKey: "AIzaSyDC39fOew4wVWrtLWlH8AMDQngW8cv2Hio",
  authDomain: "pro-akustik.firebaseapp.com",
  databaseURL: "https://pro-akustik.firebaseio.com",
  projectId: "pro-akustik",
  storageBucket: "pro-akustik.appspot.com",
  messagingSenderId: "504233337407",
  appId: "1:504233337407:web:1ee7cec387eb298aa40e8a",
  measurementId: "G-NGCYRSXV3X"
}